var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgImportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "#E1E9F0",
    fill: "#F0F4F8",
    x: -0.5,
    y: -0.5,
    width: 33,
    height: 33,
    rx: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.533 25.174a3.204 3.204 0 01-3.2-3.201v-2.134a1.067 1.067 0 112.134 0v2.134c0 .589.477 1.066 1.066 1.067h14.934c.589-.001 1.066-.478 1.066-1.067v-2.134a1.067 1.067 0 112.134 0v2.134a3.204 3.204 0 01-3.2 3.2H8.533zm8.8-18.007v7.5h2.96a.5.5 0 01.39.812l-4.293 5.366a.5.5 0 01-.78 0l-4.293-5.366a.5.5 0 01.39-.812h2.96v-7.5a.5.5 0 01.5-.5h1.666a.5.5 0 01.5.5z",
    fill: "#9BADBC"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportIcon);
export default ForwardRef;